import { css } from 'wiloke-react-core';

export const container = css`
  cursor: ew-resize !important;
`;
